import React from 'react'

export default function MapMarker(props) {
    return <div style={ styles.marker}></div>
}

const styles = {
    marker: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        width: '20px',
        height: '40px',
        display: 'block',
        content: ' ',
        margin: '-40px 0 0 -11px',
        background: "url('https://maps.gstatic.com/mapfiles/api-3/images/spotlight-poi_hdpi.png')",
        backgroundSize: '20px 40px', /* Since I used the HiDPI marker version this compensates for the 2x size */
        pointerEevents: 'none', /* This disables clicks on the marker. Not fully supported by all major browsers, though */
        backgroundRepeat: 'no-repeat'
    }
};